"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appManifestSchema = void 0;
exports.parseAppManifest = parseAppManifest;
const zod_1 = require("zod");
const permissions_1 = require("./permissions");
exports.appManifestSchema = zod_1.z.object({
    id: zod_1.z
        .string()
        .min(3)
        .max(64)
        .regex(/^[a-z0-9]+(?:[.-][a-z0-9]+)*$/),
    name: zod_1.z.string().min(1).max(80),
    version: zod_1.z.string().regex(/^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/),
    permissions: zod_1.z.array(permissions_1.appPermissionSchema).default([]),
    subscriptions: zod_1.z
        .array(zod_1.z.string().regex(/^[a-z][a-z0-9]*(?:\.[a-z0-9]+)+\.v[1-9][0-9]*$/))
        .default([]),
    webhookUrl: zod_1.z.string().url().optional(),
});
function parseAppManifest(input) {
    return exports.appManifestSchema.parse(input);
}
//# sourceMappingURL=manifest.js.map